import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AllUsersLisingPage from '../components/pages/user/view-all/content';
import NotFoundPage from './NotFoundPage.js';

function ManageAllUsersPage() {
  const usersIcanManageForAdmin = useSelector((state) => state.usersReducer.usersIcanManageForAdmin);
  const redirectToPageNotFound = useSelector((state) => state.sharedReducer.redirectToPageNotFound);
  const hasOrganisations = useSelector((state) => state.usersReducer.userProfile.hasOrganisations);
  const timezone = useSelector((state) => state.usersReducer.userProfile.timezoneOffsetNow);
  const userId = useSelector((state) => state.usersReducer.userProfile.id);
  const showOtherUsersProfileModal = useSelector((state) => state.modalReducer.showOtherUsersProfileModal);
  const showOtherUsersRolesModal = useSelector((state) => state.modalReducer.showOtherUsersRolesModal);
  const showManageInvitationsModal = useSelector((state) => state.modalReducer.showManageInvitationsModal);
  const selectedUser = useSelector((state) => state.usersReducer.selectedUserInAllUsersPage);
  const allUsersSearchForm = useSelector((state) => state.usersReducer.allUsersSearchForm);
  const hasAdminRights = useSelector((state) => state.usersReducer.userProfile.hasAdminRights);
  const searchPageSize = useSelector((state) => state.usersReducer.userProfile.userDbPageSize || 60);
  const userCallsDetails = useSelector((state) => state.usersReducer.userCallsDetails);
  const isAdmin = useSelector((state) => state.usersReducer.userProfile.isAdmin);

  const dispatch = useDispatch();

  if (!redirectToPageNotFound && hasAdminRights) {
    return (
      <AllUsersLisingPage
        userId={userId}
        dispatch={dispatch}
        timezone={timezone}
        selectedUser={selectedUser}
        isAdmin={isAdmin}
        searchPageSize={searchPageSize}
        userCallsDetails={userCallsDetails}
        allUsersSearchForm={allUsersSearchForm}
        usersIcanManageForAdmin={usersIcanManageForAdmin}
        showOtherUsersRolesModal={showOtherUsersRolesModal}
        showManageInvitationsModal={showManageInvitationsModal}
        showOtherUsersProfileModal={showOtherUsersProfileModal}
      />
    );
  } else if (redirectToPageNotFound || hasAdminRights === false) {
    return <NotFoundPage dispatch={dispatch} />;
  } else {
    // We need to use this, otherwise the NotFoundPage will flash before showing the report tiles
    return '';
  }
}

export default ManageAllUsersPage;
